<template>
<div>
    <div class="divButtonRigth" style="margin-bottom: 20px">
          <el-button type="success" size="small" @click="changeStatus('1')">启用</el-button>
        <el-button type="danger" size="small" @click="changeStatus('0')">禁用</el-button>
        <el-button v-if="this.role.tenantId=='sys'" type="primary" size="small" @click="showAddDailog">新增</el-button>
        <el-button type="primary" size="small" @click="initCacheInfo">初始化到缓存</el-button>
        <el-button type="primary" size="small" @click="backToCodeSet">返回</el-button>
    </div>
    <bsp-table
        :data="list"
        :ciic-data-filter.sync="listQuery"
        @ciic-data-refresh="_getSysInfoItemPage"
        @select-change="selectChange"
        ref="sysCodeItemTable"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column>
        <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>

        <bsp-table-column
        title="列名称"
        field="infoItemId"
        filter-type="input"
         width="180"
        >

        <template slot-scope="scope">
            <span>{{scope.row.infoItemId}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="中文名称"
        field="infoItemName"
        filter-type="input"
           width="180"

        >
        <template slot-scope="scope">
            <span>{{scope.row.infoItemName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="英文名称"
        field="infoItemEnName"
        filter-type="input"
        width="180"
        >
        <template slot-scope="scope">
            <span>{{scope.row.infoItemEnName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="数据类型"
        field="infoItemType"
        filter-type="input"
        :options-list="valueType"
        >
        <template slot-scope="scope">
            <!-- <span>{{scope.row.infoItemType | dictFilter(dicts)}}</span> -->
            <span>{{scope.row.infoItemType | dictListFilter(valueType)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="是否必填"
        field="isRequired"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{isOrNo[scope.row.isRequired]}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="默认值"
        field="defaultValue"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.defaultValue}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="输入类型"
        field="inputType"
        filter-type="input"
        :options-list="iType"
        >
        <template slot-scope="scope">
            <span>{{scope.row.inputType | dictListFilter(iType)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="编辑类型"
        field="editType"
        filter-type="input"
        :options-list="eType"
        >
        <template slot-scope="scope">
            <span>{{scope.row.editType | dictListFilter(eType)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="排序号"
        field="infoItemOrder"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.infoItemOrder}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="所属租户ID"
        field="tenantId"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.tenantId}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="状态"
        field="infoItemStatus"
        filter-type="select"
        :option-list="status"
        >
        <template slot-scope="scope">
            <!-- <el-switch
            style="display: block"
            v-model="scope.row.infoItemStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="启用"
            active-value="1"
            inactive-value="0"
            @change="changeStatus(scope.row)"
            >
            </el-switch> -->
            <span>{{scope.row.infoItemStatus | dictListFilter(status)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="分组"
        field="infoItemGroup"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.infoItemGroup}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="长度"
        field="infoItemLength"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.infoItemLength}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="描述"
        field="remark"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.remark}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="操作"
        >
        <template slot-scope="scope">
                <div class="ciic-table-operate">
                <el-button type="text" size="small" @click="showUpdateDialog(scope.row)">
                    <i class="el-icon-edit el-icon--right"></i>编辑
                </el-button>
            </div>
        </template>
        </bsp-table-column>
    </bsp-table>

    <sys-info-item-dialog
    ref="dialogForm"
    :dialog-status="dialogStatus"
    :dialog-form-visible.sync="dialogFormVisible"
    :list-form="listForm"
    :row-tenantId="this.$route.query.tenantId"
    :row-info-set-id="this.$route.query.infoSetId"
    :e-type="eType"
    :i-type="iType"
    :value-type="valueType"
    @data-refresh="_getSysInfoItemPage"
    >
    </sys-info-item-dialog>

</div>
</template>

<script>
import BspTable from "@/components/bsp/bsp-table/bsp-table";
import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
import { getSysInfoItemPage,changeSysInfoItemStatus } from "@/api/sys/info";
import SysInfoItemDialog from './SysInfoItemDialog'
import {mapGetters} from 'vuex';
export default {
    name: 'SysInfoItem',
    components: {
        BspTable,
        BspTableColumn,
        SysInfoItemDialog
    },

    created() {
        this._getSysInfoItemPage()
    },

    data() {
        return {
            loading: true,
            listForm:{},
            // 当前页面使用角色
            role:{
                name: 'admin',
                tenantId: 'sys'
            },

            // 用于接收后台返回的分页数据
            list: [],
            listQuery: {
                limit: 20,
                page: 1,
                total: 0,
                infoSetId: this.$route.query.infoSetId,
                tenantId: ''
            },
            multipleSelection: [],
            isOrNo:{
                1:'是',
                0:'否'
            },
            status:[
                {codeItemName:'禁用',codeItemId:'0'},
                {codeItemName:'启用',codeItemId:'1'}
            ],
            eType:[
                { codeItemName: '可编辑', codeItemId: '1' },
                { codeItemName: '只读', codeItemId: '2' },
                { codeItemName: '隐藏：业务上的隐藏', codeItemId: '3' }
            ],
            iType:[
                { codeItemName: '下拉框',codeItemId: '1' },
                { codeItemName: '单选', codeItemId: '2'}
            ],
            valueType:[
                { codeItemName: '整数', codeItemId: '1' },
                { codeItemName: '小数', codeItemId: '2' },
                { codeItemName: '文本', codeItemId: '3' },
                { codeItemName: '文本域', codeItemId: '4' },
                { codeItemName: '8位日期', codeItemId: '5' },
                { codeItemName: '代码', codeItemId: '6' },
                { codeItemName: '6位日期', codeItemId: '7' },
                { codeItemName: '机构类型', codeItemId: '8' },
                { codeItemName: '人员', codeItemId: '9' },
                { codeItemName: '大文本', codeItemId: '10' },
                { codeItemName: '附件', codeItemId: '11' },
                { codeItemName: '图片', codeItemId: '12' },
            ]
        }
    },

    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },

    methods: {
        // 分页查询
        _getSysInfoItemPage() {
            this.loading=true
            console.log('当前分页参数：'+JSON.stringify(this.listQuery))
            this.$set(this.listQuery, 'tenantId', this.role.tenantId)
            getSysInfoItemPage(this.listQuery).then((res) => {
                this.listQuery.total=res.data.total
                this.list=res.data.records
                this.loading=false
                console.log('当前CodeSet分页对象为：'+JSON.stringify(this.list))
            });
        },

        showAddDailog() {
          this.listForm = {
              infoSetId: this.$route.query.infoSetId
          };
          this.dialogFormVisible = true;
          this.dialogStatus = 'add';
        },
        showUpdateDialog(row) {
          this.listForm = row;
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        },
        //批量更改状态
        selectChange({checked, row}){
            if(checked){
            this.multipleSelection.push(row)
            }
            if(!checked){
                this.multipleSelection.filter((item,index) => {
                if(item===row){
                    this.multipleSelection.splice(index,1)
                }
                })
            }
        },

        changeStatus(status){
            let listSize=this.multipleSelection.length
            if(listSize==0){
                this.$message.error('请选择至少选中一行')
            }else{
                let param={
                    multipleSelection: this.multipleSelection,
                    status: status
                }
                console.log(JSON.stringify(param))
                changeSysInfoItemStatus(param).then(res =>{
                if(res.data.code==0){
                    this.$message.success(res.data.msg)
                }else{
                    this.$message.error(res.data.msg)
                }
                })
            }
        },
        backToCodeSet(){
            this.$router.go(-1)
        },

    }

}
</script>
